import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { experimentalStyled } from '@mui/material';
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../actions/auth";
import React, { useEffect } from 'react';
import { NavLink as RouterLink, useNavigate } from 'react-router-dom'
import Loading from "./Loading"
import * as Util from "../services/global.service";

const DashboardLayoutRoot = experimentalStyled('div')(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  })
);

const DashboardLayoutWrapper = experimentalStyled('div')(
  ({ theme }) => ({
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    // [theme.breakpoints.up('lg')]: {
    //   paddingLeft: 256
    // }
  })
);

const DashboardLayoutContainer = experimentalStyled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden'
});

const DashboardLayoutContent = experimentalStyled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto'
})
const toTimestamp = (strDate) => {
  if (strDate !== "" && strDate !== null && strDate !== undefined) {
    const dt = Date.parse(strDate);
    return dt / 1000
  } else {
    return 0
  }
}
const DashboardLayout = () => {
  const navigate = useNavigate()
  const [isMobileNavOpen, setMobileNavOpen] = useState(false)
  const dispatch = useDispatch()
  const user = useSelector((state) => state?.auth)
  // function expireDate() {


  var interval = setInterval(() => {
    var expireDate = localStorage.getItem('date')
    var expireDates = localStorage.getItem('expireDate')

    var timestampExpireDate = toTimestamp(expireDate)
    // var expireDateTime = new Date(expireDate).getTime().toString()
    // var dateNow = new Date()
    var dateNow = new Date().toLocaleString("en-US", { timeZone: "Asia/Bangkok" })
    var timestampDateNow = toTimestamp(dateNow)
    if (expireDate !== undefined && expireDate !== null && timestampExpireDate !== "" && isNaN(timestampExpireDate) === false && timestampDateNow >= timestampExpireDate) {
      localStorage.removeItem('date');
      localStorage.setItem('expireDate', true);
      dispatch(logout()).then(
        (response) => {
          clearInterval(interval);

          let pathTologin = response?.data?.data?.url
          if (Util.formatData(pathTologin, false) !== false) {
            const newWindow = window.open(pathTologin, '_self', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
          } else {
            console.log('Navigate', 3);
            //navigate('/' + localStorage.getItem("site"), { replace: true });
            window.location.href = '/' + localStorage.getItem("site")
          }
        }
      ).catch((err) => {
        localStorage.removeItem('date');
        localStorage.removeItem('user');
        localStorage.removeItem("proxy");
        console.log('Navigate', 4);
        //navigate('/' + localStorage.getItem("site"), { replace: true });
        window.location.href = '/' + localStorage.getItem("site")
      })
      // navigate('/'+localStorage.getItem("site"), { replace: false });
    }
    if (expireDates === true || expireDates === "true") {
      localStorage.removeItem('date');
      localStorage.setItem('expireDate', true);
      dispatch(logout()).then(
        (response) => {
          clearInterval(interval);

          let pathTologin = response?.data?.data?.url
          if (Util.formatData(pathTologin, false) !== false) {
            const newWindow = window.open(pathTologin, '_self', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
          } else {
            console.log('Navigate', 5);
            //navigate('/' + localStorage.getItem("site"), { replace: false });
            window.location.href = '/' + localStorage.getItem("site")
          }
        }
      ).catch((err) => {
        console.error(err);
        localStorage.removeItem('date');
        localStorage.removeItem('user');
        localStorage.removeItem("proxy");
        console.log('Navigate', 6);
        //navigate('/' + localStorage.getItem("site"), { replace: false });
        window.location.href = '/' + localStorage.getItem("site")
      })
      // navigate('/'+localStorage.getItem("site"), { replace: false });
    }
  }, 3000);
  // }
  useEffect(() => {
    if (user?.isLoggedIn === undefined || user?.isLoggedIn === null || user?.isLoggedIn === false) {
      console.log('Navigate', 7);
      //navigate('/' + localStorage.getItem("site"), { replace: false });
      window.location.href = '/' + localStorage.getItem("site")
    } else if (user?.user?.reset_password === true) {
      navigate('/reset-new-password', { replace: false });
    } else if (user?.user?.change_password === true) {
      navigate('/set-new-password', { replace: false });
    } else if (user?.user?.consent === false) {
      navigate('/consent', { replace: false });
    }
  }, [])

  return (
    <DashboardLayoutRoot>
      <Loading />
      <DashboardNavbar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <DashboardSidebar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
        color="black"
      />
      <DashboardLayoutWrapper>
        <DashboardLayoutContainer>
          <DashboardLayoutContent>
            <Outlet />
          </DashboardLayoutContent>
        </DashboardLayoutContainer>
      </DashboardLayoutWrapper>
    </DashboardLayoutRoot>
  );
};

export default DashboardLayout;
